import { RESET_TEAMS_BY_TOURNAMENT, SELECT_TEAM_FROM_TOURNAMENT, SET_TEAMS_BY_TOURNAMENT, SHOW_MODAL_SELECTOR_TEAMS } from "../constants/teams";

const initialState = {
    teamsByTournament:[],
    loading:false,
    selectedTeam:null,
    showModal: false,
}

function teams (state = initialState, action){
    switch (action.type) {
        case SET_TEAMS_BY_TOURNAMENT:
            return {...state, teamsByTournament: action.payload};
        case RESET_TEAMS_BY_TOURNAMENT:
            return initialState
        case SHOW_MODAL_SELECTOR_TEAMS:
            return {...state, showModal: action?.payload}
        case SELECT_TEAM_FROM_TOURNAMENT:
            return {...state, selectedTeam: action?.payload, showModal: false }
        default:
            return state;
    }

}

export default teams